import React, { Component } from 'react';

class HeaderModalStores extends Component {
  render() {
    const { closeModal = null, titleHeaderMod, withReturn = null } = this.props;
    return (
      <section className="headerModalContainer">
        <div className="titleModalContent" style={{ marginLeft: withReturn ? 0 : 18 }}>
          {
            !!withReturn && (
              <a href="#" onClick={withReturn}>
                <div className="longArrowLeft" />
              </a>
            )
          }
          <h4>{ titleHeaderMod }</h4>
        </div>

        { closeModal && (
          <span
            className="icon-tache2 closeIconModal"
            onClick={closeModal}
          />
        )}
      </section>
    );
  }
}

export default HeaderModalStores;
